import { useEffect, useRef } from "react";
import _ from "lodash";
import { Userpilot } from "userpilot";

interface useUserpilotShopTrackingProps {
  identity: any;
  location: any;
}

export default function useUserpilotShopTracking({
  identity,
  location,
}: useUserpilotShopTrackingProps) {
  const prevLocationRef = useRef<any>(location);

  useEffect(() => {
    if (!identity) return;
    Userpilot.identify(identity, {
      name: identity.user_last_name,
      email: identity.login_email,
      first_name: identity.user_first_name,
      last_name: identity.user_last_name,
      role: identity.user_role,
      has_esp: identity.has_esp,
    });
  }, [identity]);

  useEffect(() => {
    const prevLocation = prevLocationRef.current;
    if (!_.isEqual(prevLocation, location)) {
      Userpilot.reload();
    }
    prevLocationRef.current = location;
  }, [location]);
}
